/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Answer to either `yes-no-question` or `have-document-question`
 * @export
 * @interface PaxCheckBool
 */
export interface PaxCheckBool {
    /**
     * Question id
     * @type {string}
     * @memberof PaxCheckBool
     */
    questionId: string;
    /**
     * Answer value - true/false. Null to remove question answer
     * @type {boolean}
     * @memberof PaxCheckBool
     */
    value?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof PaxCheckBool
     */
    type: string;
}

/**
 * Check if a given object implements the PaxCheckBool interface.
 */
export function instanceOfPaxCheckBool(value: object): value is PaxCheckBool {
    if (!('questionId' in value) || value['questionId'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function PaxCheckBoolFromJSON(json: any): PaxCheckBool {
    return PaxCheckBoolFromJSONTyped(json, false);
}

export function PaxCheckBoolFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckBool {
    if (json == null) {
        return json;
    }
    return {
        
        'questionId': json['question_id'],
        'value': json['value'] == null ? undefined : json['value'],
        'type': json['type'],
    };
}

export function PaxCheckBoolToJSON(json: any): PaxCheckBool {
    return PaxCheckBoolToJSONTyped(json, false);
}

export function PaxCheckBoolToJSONTyped(value?: PaxCheckBool | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question_id': value['questionId'],
        'value': value['value'],
        'type': value['type'],
    };
}

